import React, { useRef } from "react";
import { useSmartFitnessBandContext } from "@icoach/smartFitnessBand/components/SmartFitnessBandContext";
import { AutocompleteField, Button, Card, Form, Grid, MenuItem, SelectField, DateIntervalField } from "@curves/ui-base";
import { refIsRequiredError } from "@util/utils";
import { PEOPLE_TYPE } from "@icoach/constants/";
import usePeopleApi from "@apis/usePeopleApi";
import useDeviceOrderApi from "@apis/useDeviceOrderApi";
import useExcelExportFlow from "@util/hook/useExcelExportFlow";
import clsx from "clsx";

const SmartFitnessBandOverviewSearchBar = () => {
	const { doSearchApi, options, getSortByFromTable } = useSmartFitnessBandContext();
	const { postDeviceOrdersExportOverviewApi } = useDeviceOrderApi();
	const { people: memberOptions } = usePeopleApi(PEOPLE_TYPE.ALLDEVICEORDERMEMBER);
	const memberIDRef = useRef(null);
	const statusRef = useRef(null);
	const dateIntervalRef = useRef(null);
	const { filterStatusOptions = [] } = options || {};

	// 搜尋與匯出共用同一組篩選條件。
	const getSearchParams = () => {
		const { startDate, endDate } = dateIntervalRef.current.getResult();
		return {
			memberID: memberIDRef.current.getResult("id") * 1 || 0,
			status: statusRef.current.getResult() * 1 || null,
			startDate,
			endDate,
		};
	};

	const getExportParams = () => ({
		...getSearchParams(),
		// sortBy 由表格 ListInfo 當前排序取得，避免固定值
		sortBy: getSortByFromTable?.() || 1,
	});

	// 搜尋與匯出共用同一套必要欄位檢核
	const hasSearchError = () => refIsRequiredError(memberIDRef, statusRef);

	const handleSearch = () => {
		if (hasSearchError()) return;
		doSearchApi(getSearchParams());
	};

	const { onExcelOnClick } = useExcelExportFlow({
		validate: () => !hasSearchError(),
		getExportParams,
		exportApi: postDeviceOrdersExportOverviewApi,
	});

	return (
		<Card className={clsx("search-bar-light px-4 py-3")}>
			<Card.CardContent>
				<Form onSubmit={handleSearch}>
					<Grid spacing={3} container>
						<Grid xs={4} item>
							<AutocompleteField
								ref={memberIDRef}
								options={memberOptions}
								className="flex-auto"
								label="租用會員"
								optionKeys={["name", "nickName", "mobile", "no"]}
								optionMaskKeys={["maskName", "nickName", "maskMobile", "no"]}
								primaryKey="id"
								inputProps={{
									placeholder: "請輸入會員姓名或手機號碼或會員編號",
								}}
								fullWidth
							/>
						</Grid>
						<Grid xs={8} item>
							<DateIntervalField ref={dateIntervalRef} startDateProps="" endDateProps="" label="訂閱日期區間" fullWidth />
						</Grid>
						<Grid xs={4} item>
							<SelectField ref={statusRef} label="訂閱狀態" defaultValue={1} fullWidth required>
								{filterStatusOptions.map(({ text, value }) => (
									<MenuItem value={value} key={value}>
										{text}
									</MenuItem>
								))}
							</SelectField>
						</Grid>
						<Grid className="text-right" xs={12} item>
							<Button className="mb-1 white-space-nowrap" type="submit" variant="contained">
								搜尋
							</Button>
							<Button className="mb-1 ml-2 white-space-nowrap" variant="contained" color="success" onClick={onExcelOnClick}>
								下載Excel
							</Button>
						</Grid>
					</Grid>
				</Form>
			</Card.CardContent>
		</Card>
	);
};

export default SmartFitnessBandOverviewSearchBar;
